import { NewFeedPictureModel } from "../../newfeeds/models/NewFeedModel";
import {
    CollageLayout, CollageLayoutManager, PhotoCollageStyle, PhotoSize
} from "../models/PhotoCollageModel";
import { CollageProps } from "./TwoPhotoView";

export default function FourPhoto({ photos, photoManager, layout }: CollageProps) {
    const layoutManager = new CollageLayoutManager(layout);

    const style = new PhotoCollageStyle(
        photoManager.dimension.getSpacing(),
        layoutManager.isTall()
    );

    const smallStyle: React.CSSProperties = {
        display: style.innerDisplay,
        paddingBottom: style.paddingBottom,
        paddingRight: style.paddingRight
    };

    const allSquares = (): JSX.Element => {
        const space = photoManager.dimension.getSpacing();

        return <div style={{ display: "inline-block" }}>
            <div style={{ paddingBottom: space }}>
                <div style={{ float: "left", display: "flex", paddingRight: space }}>
                    {photoManager.getSquare(photos[0], PhotoSize.half)}
                </div>
                <div style={{ display: "flex" }}>
                    {photoManager.getSquare(photos[1], PhotoSize.half)}
                </div>
            </div>

            <div>
                <div style={{ float: "left", display: "flex", paddingRight: space }}>
                    {photoManager.getSquare(photos[2], PhotoSize.half)}
                </div>
                <div style={{ display: "flex" }}>
                    {photoManager.getSquare(photos[3], PhotoSize.half)}
                </div>
            </div>
        </div>;
    }

    const large = (photo: NewFeedPictureModel): JSX.Element => {
        return <>
            {photoManager.getRectangle(
                photo,
                layoutManager.isHalf() ? PhotoSize.half : PhotoSize.twoThird,
                PhotoSize.full,
                layoutManager.isTall()
            )}
        </>;
    }

    const small = (photo: NewFeedPictureModel): JSX.Element => {
        return <>
            {photoManager.getRectangle(
                photo,
                layoutManager.isHalf() && layoutManager.isTall() ?
                    PhotoSize.half : PhotoSize.oneThird,
                PhotoSize.oneThird,
                layoutManager.isTall()
            )}
        </>;
    }

    if (layout === CollageLayout.allSquare) {
        return allSquares();
    }

    return <div style={{ display: "inline-block" }}>
        <div style={{
            float: style.outerFloat,
            paddingRight: style.paddingBottom,
            paddingBottom: style.paddingRight
        }}>
            {large(photos[0])}
        </div>
        <div style={{ float: style.innerFloat }}>
            <div style={smallStyle}>{small(photos[1])}</div>
            <div style={smallStyle}>{small(photos[2])}</div>
            <div style={smallStyle}>{small(photos[3])}</div>
        </div>
    </div>;
}